import { createApp } from 'vue';
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc';
import I18NextVue from 'i18next-vue';
import { VDialog } from 'vuetify/components/VDialog';
import { DefaultLayout, LoadingLayout } from '@layouts';
import 'babel-polyfill';
import JsonExcel from 'vue-json-excel3';
import modalPlugin from '@plugins/modal/modalPlugin.js';
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';
import infiniteScroll from 'vue-infinite-scroll';
import testIdPlugin from '@plugins/TestIdPlugin';
import LoadScript from 'vue-plugin-load-script';
import { userAccessControlsUtils } from '@utils/user';
import { i18nFactory, routerFactory, storeFactory, vuetifyFactory } from './index';
import App from '@/App.vue';

export default {
    create: (config) => {
        const i18nKey = i18nFactory.create(config.i18nKey || {});
        const router = routerFactory.create({ routes: config.routes || [] });
        const vuetify = vuetifyFactory.create(config.theme);
        const store = storeFactory.create(config.store);

        router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidcStore'));
        router.beforeEach((to, from, next) => {
            if (to.meta.checkAccessControlsBeforeEnter) {
                if (store.getters['user/isLoaded'] && store.getters['user/roles'].length > 0) {
                    userAccessControlsUtils.secureRouteBeforeEnter(store, to, next);
                } else {
                    setTimeout(() => {
                        userAccessControlsUtils.secureRouteBeforeEnter(store, to, next);
                    }, 100);
                }
            } else {
                next();
            }
        });

        const app = createApp(App);
        app.use(I18NextVue, { i18next: i18nKey });
        app.use(router);
        app.use(vuetify);
        app.use(store);

        app.component('default-layout', DefaultLayout);
        app.component('loading-layout', LoadingLayout);
        app.component('downloadExcel', JsonExcel);

        /**
         * TODO migration
         * Vuetify don't have v-bottom-sheet ( still in labs ).
         * We will add v-bottom-sheet but it still v-dialog
         */
        app.component('v-bottom-sheet', VDialog);

        app.use(modalPlugin);
        app.use(VCalendar, { componentPrefix: 'VC' });
        app.use(infiniteScroll);
        app.use(testIdPlugin);
        app.use(LoadScript);

        app.mount('#app');

        return app;
    },
};
